export default __webpack_public_path__ + "static/media/link.52a15bae.svg";